module.exports = __webpack_public_path__ + "2d590f8a3cd0425a48ea6fe03744a0d8.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-main-1080.webp.png
// module id = 359
// module chunks = 0